export const SESSION_STATE_ENDPOINT = '/api/auth/me';
export const SESSION_LOGIN_ENDPOINT = '/api/auth/login';
export const SESSION_LOGOUT_ENDPOINT = '/api/auth/logout';

export const UNAUTHORIZED_STATUS = 401;

export const SESSION_STATE_RETRY_DELAY = 5 * 1000;

export const SESSION_LOGIN_ATTEMPT_KEY = 'session.loginAttempted';

export const SESSION_STATE = {
  ACTIVE: 'ACTIVE',
  ABSENT: 'ABSENT',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;
